import { getAuthorizationHeader, handleQueryError } from "../helpers/RtkQueryUtils";
import { serialize } from "../helpers/Utils";
import { dmApi } from "./dmApi";

export const globalApi = dmApi.injectEndpoints({
    endpoints: (build) => ({
        getRoles: build.query({
            query: (data) => {
                let paramData = serialize(data);
                return {
                    url: `/roles?${paramData}`,
                    method: "GET",
                    headers: getAuthorizationHeader()
                };
            },
            providesTags: ['getAllRoles'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),
        getSummary: build.query({
            query: (data) => {
                let paramData = serialize(data);
                return {
                    url: `/receiving-data/summary?${paramData}`,
                    method: 'GET',
                    headers: getAuthorizationHeader()
                };
            },
            providesTags: ['getAllSummary'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),
        getUnloadingSummary: build.query({
            query: (data) => {
                let paramData = serialize(data);
                return {
                    url: `/receiving-data/unloading/summary?${paramData}`,
                    method: 'GET',
                    headers: getAuthorizationHeader()
                };
            },
            providesTags: ['getUnloadingSummary'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),
        getWashingAreaSummary: build.query({
            query: (data) => {
                let paramData = serialize(data);
                return {
                    url: `/receiving-data/washing-area/summary?${paramData}`,
                    method: 'GET',
                    headers: getAuthorizationHeader()
                };
            },
            providesTags: ['getWashingAreaSummary'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),
        getRejectionLogSummary: build.query({
            query: (data) => {
                let paramData = serialize(data);
                return {
                    url: `/receiving-data/rejected-logs/summary?${paramData}`,
                    method: 'GET',
                    headers: getAuthorizationHeader()
                };
            },
            providesTags: ['getRejectionLogSummary'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),
        getReceivingEmployeeSummary: build.query({
            query: (data) => {
                let paramData = serialize(data);
                return {
                    url: `/receiving-data/employees-data?${paramData}`,
                    method: 'GET',
                    headers: getAuthorizationHeader()
                };
            },
            providesTags: ['employeeReceiving'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),
        getWorkingAreas: build.query({
            query: (data) => {
                let paramData = serialize(data);
                return {
                    url: `/working-areas?${paramData}`,
                    method: "GET",
                    headers: getAuthorizationHeader()
                };
            },
            providesTags: ['workingAreas'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),
        getAttendanceOverview: build.query({
            query: (data) => {
                let paramData = serialize(data);
                return {
                    url: `/attendance/overview?${paramData}`,
                    method: 'GET',
                    headers: getAuthorizationHeader()
                };
            },
            providesTags: ['attendanceOverview'],
            async onQueryStarted(_, { queryFulfilled }) {
                await handleQueryError(queryFulfilled)
            },
        }),
        getAllWorkingAreas: build.query({
            query: () => {
                return {
                    url: `/working-areas`,
                    method: 'GET',
                    headers: getAuthorizationHeader()
                };
            },
            providesTags: ['allWorkingAreas'],
            async onQueryStarted(_, { queryFulfilled }) {
                await handleQueryError(queryFulfilled)
            },
        }),
        getPallets: build.query({
            query: (data) => {
                let paramData = serialize(data);
                return {
                    url: `/pallets?${paramData}`,
                    method: "GET",
                    headers: getAuthorizationHeader()
                };
            },
            providesTags: ['getPallets'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),
        getRefrigerationPallets: build.query({
            query: (data) => {
                let paramData = serialize(data);
                return {
                    url: `/refrigeration-pallets?${paramData}`,
                    method: "GET",
                    headers: getAuthorizationHeader()
                };
            },
            providesTags: ['getRefrigerationPallets'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),
        getAboutMe: build.query({
            query: () => {
                return {
                    url: `/about-me`,
                    method: "GET",
                    headers: getAuthorizationHeader()
                };
            },
            providesTags: ['aboutMe'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),
    }),
})

export const {
    useGetRolesQuery,
    useGetSummaryQuery,
    useGetUnloadingSummaryQuery,
    useGetWashingAreaSummaryQuery,
    useGetRejectionLogSummaryQuery,
    useGetReceivingEmployeeSummaryQuery,
    useGetWorkingAreasQuery,
    useGetAttendanceOverviewQuery,
    useGetAllWorkingAreasQuery,
    useGetPalletsQuery,
    useGetRefrigerationPalletsQuery,
    useGetAboutMeQuery
} = globalApi;